import React from 'react';
import { graphql } from "gatsby";
import { makeStyles } from '@material-ui/styles';
import {buildBlocks} from "../../../services/builder";
import Grid from '@material-ui/core/Grid';
import styles from './styles';

const useStyles = makeStyles(theme => styles(theme));

export const CgbThickIntroBlock = (props) => {
    const blocks = buildBlocks(props.innerBlocks, props.parentAttributes, props.pageContext);
    const classes = useStyles();

    return <div className={`thick-intro ${props.attributes.className ? props.attributes.className : ''} ${classes.thickIntro} ${classes.thickIntroTheme}`}>
        <Grid container spacing={3} direction="row">
            <Grid item xs={12} md={9} lg={8} >
                {blocks[0]}
                {blocks[1]}
                {props.attributes.hasButton &&
                    blocks[2]
                }
            </Grid>
        </Grid>
    </div>
};

export const CgbThickIntroBlockFragment = graphql`
  fragment CgbThickIntroBlock on WpBlock {
    ... on WpCgbThickIntroBlock {
        name
        attributes {
            className
            hasButton
        }
      }
  }`;

// This is the string version of this that is used within previews and without WP prefixes
export const CgbThickIntroBlockPreview = `
    ... on CgbThickIntroBlock {
        name
        attributes {
            className
            hasButton
        }
    }
`;